<template>
    <div class="email-logs-component">
        <b-table v-if="!isFetching" 
            striped
            hover
            show-empty
            :items="logs"
            :fields="fields"
            :per-page="5"
            :busy="isFetching"
            :empty-text="$t('emailLog.noMailSent')">

            <template v-slot:cell(subtype)="row">
                <span>{{ $t(`emailLog.${row.item.type}.${row.item.subtype}`) }}</span>
            </template>

            <template v-slot:cell(status)="row">
                <span>{{ $t(`emailLog.status.${row.item.status}`) }}</span>
            </template>

            <template v-slot:cell(created_at)="row">
                <span>{{ (new Date(row.item.created_at)).toLocaleString() }}</span>
            </template>

            <template v-slot:cell(actions)="row">
                <b-btn-group class="pull-right">
                    <b-btn variant="primary"
                        v-b-tooltip.hover
                        v-bind:disabled="fetchingContent"
                        @click="getContent(row.item.id)"
                        :title="$t('emailLog.actions.seeContent')"
                    >
                        <fa-icon icon="envelope-open" fixed-width />
                    </b-btn>

                    <b-btn variant="primary"
                        v-if="row.item.attachment"
                        v-b-tooltip.hover
                        v-bind:disabled="fetchingAttachment"
                        @click="downloadAttachment(row.item)"
                        :title="$t('emailLog.actions.downloadAttachment')"
                    >
                        <fa-icon icon="file-pdf" fixed-width />
                    </b-btn>
                </b-btn-group>
            </template>
        </b-table>
    </div>
</template>

<script>
import EmailLogService from '@/services/email-log-service.js';

export default {
    components: {},
    props: {
        logs: {
            type: Array,
            default: () => [],
        },

        isFetching: {
            type: Boolean,
            default: false,
        }
    },
    data: function () { return {
        fields: [
            { key: 'subtype',     label: this.$t('emailLog.type') },
            { key: 'status',      label: this.$t('emailLog.status') },
            { key: 'created_at',  label: this.$t('emailLog.createdAt') },
            { key: 'actions',     label: this.$t('emailLog.actions'), class: 'text-right' },
        ],

        fetchingContent:    false,
        fetchingAttachment: false,
    }},
    computed: {},
    methods: {
        async getContent(id) {
            this.fetchingContent = true;

            try {
                const content = await EmailLogService.getContent(id);

                this.fetchingContent = false;

                let newWindow = window.open("about:blank", "", "_blank");
                newWindow.document.write(content);
                newWindow.focus();
            }
            catch (error) {
                this.fetchingContent = false;
                console.log(error);
            }
        },

        async downloadAttachment(log) {
            this.fetchingAttachment = true;

            try {
                const response = await EmailLogService.getAttachment(log.id);
                const data = window.URL.createObjectURL(response);
				const dateString = `${(new Date()).toLocaleString()}`
				let aTag = document.createElement('a');
				
				aTag.href = data;
				aTag.download = `Bijlage ${dateString}.pdf`;
				aTag.style = "position: absolute; opacity: 0;";
				aTag.target = '_blank';
				
				document.body.appendChild(aTag);
				aTag.click();

				setTimeout(function () {
					document.body.removeChild(aTag);
					window.URL.revokeObjectURL(data);
				}, 100);

                this.fetchingAttachment = false;

                return content;
            }
            catch (error) {
                this.fetchingAttachment = false;
                console.log(error);
            }
        }
    },
    mounted: function () {}
}
</script>

<style lang="scss">
.email-logs-component {}
</style>


// WEBPACK FOOTER //
// EmailLogsComponent.vue?2f5b7a20